export { default as useWhatsappQuery } from './use-whatsapp-query';
